(function (angular) {
  "use strict";

  angular.module("app").directive("fileDrop", fileDrop);

  fileDrop.$inject = ["alerts", "settings", "$uibModal", "Upload"];

  function fileDrop(alerts, settings, $uibModal, Upload) {
    function fileDropLink($scope) {
      // properties
      $scope.options = angular.merge(
        {
          filePattern: "image/*",
          maxFilesize: settings.maxUploadSize,
          dragOverClass: "dragging",
          resize: false,
          resizeSize: {
            w: 200,
            h: 200,
          },
          resizeShape: "square",
          resizeAspectRatio: 1,
        },
        $scope.options,
      );

      // methods
      $scope.handleFile = handleFile;

      /**
       * Converts bytes to a formatted size string in megabytes
       *
       * @param {number} bytes
       * @return {string}
       */
      function bytesToMb(bytes) {
        return (bytes / 1000000).toFixed(2) + "Mb";
      }

      /**
       * Resizes image if requested, then passes to parent controller
       * @param  {file} file - file object provided by ngUpload plugin
       * @return {void}
       */
      function handleFile(file) {
        // Don't do anything if the file is empty
        if (!file || !file.name) {
          return false;
        }

        // Validate filesize if we won't be resizing the image
        if (!$scope.options.resize && file.size > $scope.options.maxFilesize) {
          $scope.onError({
            image: `Maximum filesize is ${bytesToMb($scope.options.maxFilesize)}`,
          });
          return false;
        }

        // convert to base64
        Upload.base64DataUrl(file).then(function (base64Image) {
          if (!base64Image) {
            alerts.emit({
              title: "Image couldn't be converted to the correct format",
              theme: "error",
            });
          } else {
            // resize and return
            if ($scope.options.resize) {
              $uibModal
                .open({
                  templateUrl: "modals/resize-image.html",
                  controller: "resizeImageController",
                  controllerAs: "vm",
                  windowClass: "resize-image",
                  resolve: {
                    originalImage: function () {
                      return base64Image;
                    },
                    resizeOptions: function () {
                      return {
                        shape: $scope.options.resizeShape,
                        size: $scope.options.resizeSize,
                        aspectRatio: $scope.options.resizeAspectRatio,
                      };
                    },
                  },
                })
                .result.then(function (resizedImage) {
                  $scope.onSelect(resizedImage);
                });
            } else {
              $scope.onSelect(base64Image, file);
            }
          }
        });
      }
    }

    return {
      templateUrl: "directives/file-drop.html",
      transclude: true,
      scope: {
        /**
         * Value of "name" html attribute
         *
         * @type {string}
         */
        name: "=?",
        ngModel: "=?",
        url: "=?",
        onSelect: "=",
        onError: "=",
        options: "=?",
      },
      link: fileDropLink,
    };
  }
})(angular);
